/**
 * Логистика Яндекс.Маркет по весу (таблица тарифов).
 *
 * Единственная реализация для бэкенда и фронтенда. До выноса дублировалась:
 *   - project/src/utils/calc/calcLogisticByWeight.ts (внутренний хелпер бэка)
 *   - project/src/utils/calcYandexPrice.ts (оригинальная приватная копия)
 *   - front/src/components/Settings/helpers/calcYaLogisticByWeight.ts
 *
 * Пороги и значения тарифов продиктованы Яндекс.Маркетом; менять их нельзя —
 * это бизнес-контракт. Значения округлены до рублей.
 */
export const calcLogisticByWeight = (weight: number): number => {
  if (weight < 0.2) return 80;
  if (weight < 0.5) return 85;
  if (weight < 1) return 95;
  if (weight < 2) return 135;
  if (weight < 4) return 190;
  if (weight < 6) return 270;
  if (weight < 8) return 360;
  if (weight < 10) return 440;
  if (weight < 12) return 530;
  if (weight < 15) return 640;
  if (weight < 20) return 800;
  if (weight < 25) return 1000;
  if (weight < 30) return 1200;
  if (weight < 35) return 1400;
  if (weight < 50) return 1800;
  if (weight < 150) return 2300;
  return 3500;
};